<template>
  <v-list two-line>
    <v-list-item>
      <v-list-item-avatar class="ml-3 mr-6">
        <v-icon class="indigo" dark> mdi-account </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title
          >{{ $t("messanger.chat.messages_options.showMessageInfos.sender") }} :
        </v-list-item-title>
        <v-list-item-subtitle class="black--text">
          <h3 style="white-space: pre-wrap">
            {{ sender(message.sender_type) }}
          </h3>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-avatar class="ml-3 mr-6">
        <v-icon class="indigo" dark> mdi-send-clock </v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title
          >{{ $t("messanger.chat.messages_options.showMessageInfos.sent_at") }}
          :
        </v-list-item-title>
        <v-list-item-subtitle class="black--text">
          <h3 style="white-space: pre-wrap">
            {{ time_format(message.sent_at || message.send_time) }}
          </h3>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="message.current_url">
      <v-list-item-avatar class="ml-3 mr-6">
        <v-icon class="indigo" dark> mdi-link </v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title
          >{{
            $t("messanger.chat.messages_options.showMessageInfos.current_url")
          }}
          :
        </v-list-item-title>
        <v-list-item-subtitle class="black--text">
          <h3 style="white-space: pre-wrap">{{ message.current_url }}</h3>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-if="message.ts_slack">
      <v-list-item-avatar class="ml-3 mr-6">
        <v-icon class="indigo" dark> mdi-slack </v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title> Sent from: </v-list-item-title>
        <v-list-item-subtitle class="black--text">
          <h3 style="white-space: pre-wrap">Slack</h3>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-if="message.message_logs && message.message_logs.length">
      <v-list-item-avatar class="ml-3 mr-6">
        <v-icon class="indigo" dark> mdi-file-code-outline </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title> LLM logs: </v-list-item-title>
        <v-expansion-panels class="mt-2 px-2" accordion>
          <v-expansion-panel
            v-for="(log, index) in message.message_logs"
            :key="index"
          >
            <v-expansion-panel-header>
              <div>
                <strong>Log #{{ index + 1 }}</strong>
                <span class="ml-3 text--secondary">
                  {{ log.event_type }} - {{ log.source }}
                </span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-3">
                <div class="mb-2">
                  <strong>Log ID:</strong> <code>{{ log.message_log_id }}</code>
                </div>
                <div class="mb-2">
                  <strong>Created at:</strong>
                  <code>{{ time_format(log.created_at) }}</code>
                </div>
                <div class="mb-2">
                  <strong>Source:</strong> <code>{{ log.source }}</code>
                </div>
                <div class="mb-2">
                  <strong>Event type:</strong> <code>{{ log.event_type }}</code>
                </div>
              </div>
              <div class="llm_logs_json">
                <!-- copy btn -->
                <v-btn
                  icon
                  @click="copyText(log.content)"
                  absolute
                  top
                  right
                  small
                  class="mx-10"
                >
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
                <pre><code>{{ log.content }}</code></pre>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-list-item-content>
    </v-list-item>
    <v-list-item v-if="message.reactions && message.reactions.length">
      <v-list-item-avatar class="ml-3 mr-6">
        <v-icon class="indigo" dark> mdi-emoticon-happy-outline </v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title> Reactions: </v-list-item-title>
        <v-expansion-panels class="mt-2 px-2" accordion>
          <v-expansion-panel
            v-for="(reaction, index) in message.reactions"
            :key="index"
          >
            <v-expansion-panel-header>
              <div>
                <strong>Reaction #{{ index + 1 }}</strong>
                <span class="ml-3 text--secondary">
                  {{ reaction.reaction_type || reaction.emoji || "Reaction" }}
                </span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="mb-3">
                <div class="mb-2" v-if="reaction.reaction_id">
                  <strong>Reaction ID:</strong>
                  <code>{{ reaction.reaction_id }}</code>
                </div>
                <div class="mb-2" v-if="reaction.reaction_type">
                  <strong>Type:</strong>
                  <code>{{ reaction.reaction_type }}</code>
                </div>
                <div class="mb-2" v-if="reaction.reaction_category">
                  <strong>Category:</strong>
                  <code>{{ reaction.reaction_category }}</code>
                </div>
                <div class="mb-2" v-if="reaction.created_at">
                  <strong>Created at:</strong>
                  <code>{{ time_format(reaction.created_at) }}</code>
                </div>
              </div>
              <div class="llm_logs_json" v-if="reaction">
                <!-- copy btn -->
                <v-btn
                  icon
                  @click="copyText(reaction)"
                  absolute
                  top
                  right
                  small
                  class="mx-10"
                >
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
                <pre><code>{{ reaction }}</code></pre>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  props: {
    message: null,
  },
  components: {},
  created() {},
  data() {
    return {};
  },
  methods: {
    copyText(text) {
      try {
        text = JSON.stringify(text, null, 2);
        console.log("copy : ", text);
        if (navigator.clipboard != undefined) {
          //Chrome
          navigator.clipboard.writeText(text).then((r) => {
            this.$store.dispatch("setSnackbar", {
              text: "Copy",
              color: "info",
              timeout: 800,
            });
          });
        } else if (window.clipboardData) {
          // Internet Explorer
          window.clipboardData.setData("Text", text);
        }
      } catch (e) {
        this.$store.dispatch("setSnackbar", {
          text: "Error copying text",
          color: "error",
          timeout: 2000,
        });
        console.error("Error copying text: ", e);
      }
    },
    sender(type) {
      let result = type;
      if (type === "self") {
        result =
          this.$store.state.chat_user.firstname ||
          this.$store.state.chat_user.email ||
          this.$store.state.chat_user.contact ||
          `#${this.$store.state.chat_user.id}`;
      } else if (type === "bot") {
        result = "Box Cleed";
      } else {
        result = "Admin";
      }
      return result;
    },
    time_format(time) {
      const options = {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      };

      const d = (new Date(time) + "").split(" ");
      const tmp = [d[2], d[1], d[3], d[4]].join(" ");
      const b = new Date();
      const a = new Date(tmp);
      let diff = Math.abs(a - b);
      const ms = diff % 1000;
      diff = (diff - ms) / 1000;
      const ss = diff % 60;
      diff = (diff - ss) / 60;
      const mm = diff % 60;
      diff = (diff - mm) / 60;
      const hh = diff % 24;
      const days = (diff - hh) / 24;

      if (!days && !hh && !mm) {
        return "a few seconds";
      } else {
        return new Date(time).toLocaleDateString(
          this.$i18n.locale == "fr" ? "fr-FR" : "en-US",
          options
        );
      }
    },
  },
};
</script>

<style scoped>
.llm_logs_json {
  max-height: 300px;
  overflow-y: auto;
  background-color: #f5f5f5;
  padding: 12px;
  border-radius: 4px;
}
</style>
